import { atom } from 'jotai/index';

export const ldHashAtom = atom<string | undefined>(undefined);
